import { computed, defineNuxtPlugin, useState, watch } from "#imports";
import { easyTextsLoader } from "#nuxt-easy-texts/loader";
import { getPluralTexts, getSingleText } from "../helpers/textsFunctions.js";
export default defineNuxtPlugin({
  name: "nuxt-easy-texts",
  dependsOn: easyTextsLoader.options.dependsOn,
  setup: async () => {
    const loader = easyTextsLoader.getLoader();
    const currentLanguage = "currentLanguage" in loader ? loader.currentLanguage() : loader.reloadTrigger ? loader.reloadTrigger() : computed(() => "und");
    const isDebug = useState(
      "nuxt_easy_texts_debug_enabled",
      () => false
    );
    const translations = useState(
      "nuxt_easy_texts",
      () => {
        return {};
      }
    );
    if (!translations.value[currentLanguage.value]) {
      translations.value[currentLanguage.value] = await loader.load(
        currentLanguage.value
      );
    }
    async function loadTranslationsForLanguage(language, force) {
      if (translations.value[language] && !force) {
        return translations.value[language];
      }
      const data = await loader.load(language);
      translations.value[language] = data;
      return data;
    }
    if (import.meta.client) {
      watch(currentLanguage, (newLanguage) => {
        loadTranslationsForLanguage(newLanguage);
      });
    }
    if (import.meta.hot) {
      import.meta.hot.on(
        "nuxt-easy-texts:reload",
        () => loadTranslationsForLanguage(currentLanguage.value, true)
      );
    }
    const currentTranslations = computed(() => {
      return translations.value[currentLanguage.value] || {};
    });
    const $texts = (key, replacements) => {
      return getSingleText(
        key,
        isDebug.value,
        currentTranslations.value,
        replacements
      );
    };
    const textsPlural = (key, count, replacements) => {
      return getPluralTexts(
        key,
        count,
        isDebug.value,
        currentTranslations.value,
        replacements
      );
    };
    return {
      provide: {
        nuxtEasyTexts: {
          loadTranslationsForLanguage,
          currentLanguage
        },
        texts: $texts,
        textsPlural
      }
    };
  }
});
